// frontend/modules/document-type/views/DocumentTypeCreateView.tsx
import React from 'react';
import { Typography, Button, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { DocumentTypeForm } from '../components/DocumentTypeForm';
import { useDocumentTypes } from '../hooks/useDocumentTypes';
import { DocumentTypeFormData } from '../types/document-type.types';

const { Title } = Typography;

export const DocumentTypeCreateView: React.FC = () => {
    const navigate = useNavigate();
    const { createDocumentType } = useDocumentTypes();

    const handleSubmit = async (data: DocumentTypeFormData) => {
        try {
            await createDocumentType.mutateAsync({ data });
            navigate('/admin/document-types/management');
        } catch (error) {
            console.error('Failed to create document type:', error);
        }
    };

    const handleCancel = () => {
        navigate('/admin/document-types/management');
    };

    return (
        <div style={{ padding: 24 }}>
            <div style={{ marginBottom: 24 }}>
                <Space>
                    <Button
                        type="text"
                        icon={<ArrowLeftOutlined />}
                        onClick={() => navigate('/admin/document-types/management')}
                    >
                        Back to Document Types
                    </Button>
                </Space>
                <Title level={2} style={{ margin: '16px 0 0 0' }}>
                    Create New Document Type
                </Title>
            </div>

            <DocumentTypeForm
                onSubmit={handleSubmit}
                onCancel={handleCancel}
                loading={createDocumentType.isPending}
                isEdit={false}
            />
        </div>
    );
};
